import { BLOG_ARTICLES } from "@config/blog-config";
import petr from "@public/static/story/petr-bosak.png";
import { BlogHeroSection } from "@shared/components/blog/blog-hero-section";
import { IntroSection } from "@shared/components/blog/intro-section";
import { MainSection } from "@shared/components/blog/main-section";
import { Sidebar } from "@shared/components/blog/sidebar";
import { useLocale } from "@translations/locale-context";
import { StaticImage } from "@ui/components/image/static-image";
import { useTranslation } from "next-i18next";
import React, { FC, memo } from "react";

const ContentCs: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Kdo jsi?</h2>
        <p className="mb-6">
            Vystudoval jsem střední průmyslovou školu obor strojírenství a&nbsp;management v&nbsp;podnikání
            na&nbsp;vysoké škole. Od 3&nbsp;let jsem se&nbsp;věnoval hokeji. Na&nbsp;konci kariéry jsem u&nbsp;hokeje
            chtěl zůstat, a&nbsp;tak jsem se&nbsp;dal na&nbsp;dráhu hokejového rozhodčího, která trvala 14&nbsp;let,
            z&nbsp;toho 7&nbsp;let jsem působil v&nbsp;první lize. Celé mé fungování v&nbsp;hokeji mě naučilo hlavně
            týmové práci, ve&nbsp;které potřebuji fungovat i&nbsp;v pracovním týmu k&nbsp;tomu, abych se&nbsp;cítil
            komfortně a&nbsp;práce mě bavila.
        </p>
        <p className="mb-6">
            Rád trávím čas se&nbsp;svou rodinou a&nbsp;cestováním, což je také důvodem, proč jsme si se&nbsp;ženou
            založili cestovní agenturu.
        </p>
        <p>Mimo hokeje, cyklistiky a&nbsp;lyžování patří k&nbsp;mým koníčkům i&nbsp;práce v&nbsp;UX Fans.</p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co bylo před UX Fans?</h2>
        <p className="mb-6">
            První pracovní zkušenosti jsem získal v&nbsp;průběhu střední školy v&nbsp;rodinné firmě mého táty.
            Nakupovali jsme a&nbsp;prodávali dekorativní výrobky ze&nbsp;skla. Hlavní kupní silou byli turisté.
            S&nbsp;příchodem koronaviru se&nbsp;tržby propadly téměř na&nbsp;nulu. To byl hlavní důvod mého odchodu.
        </p>
        <p className="mb-6">
            Hledal jsem tedy práci ve&nbsp;firmě, kterou neovlivní koronavirus a&nbsp;nastoupil jsem do&nbsp;společnosti
            Cryrtur v&nbsp;Turnově jako produktový manažer. Po&nbsp;pár měsících jsem nabyl dojmu, že produktový manažer
            je především nárazník mezi obchodem a&nbsp;výrobou. Stejně tak jsem zjistil, že si někteří kolegové chodí
            pracovní dobu „jen odsedět“. To mi nevyhovovalo, a&nbsp;proto jsem se&nbsp;asi po&nbsp;dvou až třech
            měsících začal po&nbsp;večerech učit programovat s&nbsp;vidinou pracovní příležitosti, kam bych
            se&nbsp;každé ráno těšil a&nbsp;večer odcházel s&nbsp;lehkým smutkem na&nbsp;srdci, že přijdu zase až druhý
            den.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Co tě do UX Fans přivedlo?</h2>
        <p className="mb-6">
            Věděl jsem, že do&nbsp;další výrobní firmy na&nbsp;podobnou pozici již nechci. Odeslal jsem několik
            životopisů na&nbsp;pozice v&nbsp;IT, ale nikdo nepřišel s&nbsp;konkrétní nabídkou. Až jednou, mezi řečí
            s&nbsp;Martinem (CEO UX Fans) jsem se&nbsp;zmínil, že nějakou dobu programuju, baví mě to a&nbsp;hledám
            víceméně jakoukoliv pozici v&nbsp;IT, kde bych se&nbsp;mohl dále rozvíjet.
        </p>
        <p className="mb-6">
            V&nbsp;UX Fans se&nbsp;v&nbsp;té době rozjelo několik projektů a&nbsp;potřebovali testera. Následovala další
            schůzka s&nbsp;Martinem, kde mi detailněji představil formu spolupráce a&nbsp;pracovní náplň. Další den jsem
            v&nbsp;Turnově nesl svou výpověď na&nbsp;personální oddělení.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Jaká je tvoje role v UX Fans?</h2>
        <p className="mb-6">
            V&nbsp;UX Fans pracuji jako tester softwaru. Kromě testování právě vyvinuté funkcionality zahrnuje moje
            práce i&nbsp;řadu dalších aktivit, které vedou k&nbsp;úspěšným releasům a&nbsp;tím pádem
            i&nbsp;ke&nbsp;spokojeným zákazníkům. Jednou z&nbsp;hlavních aktivit, kterým se&nbsp;věnuji a&nbsp;které
            vedou k&nbsp;úspěšnému dodání softwaru a&nbsp;tím i&nbsp;splňování QA, je i&nbsp;testování softwaru jako
            celku a&nbsp;jeho návazností z&nbsp;pohledu klientského, obchodního nebo uživatelského. Navíc se&nbsp;věnuji
            také psaní testovacích scénářů, akceptačních kritérií, automatizovaných end-to-end testů a&nbsp;testů
            vizuální regrese, které jsou nedílnou součástí pro správné QA.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Baví tě být součástí UX Fans?</h2>
        <p>
            No jasně :) Strašně mě baví koukat se&nbsp;na UX Fans jako na&nbsp;skvěle pracující soukolí, kde by jedno
            ozubené kolečko žádnou velkou slávu nepředvedlo, ale zapojením celé soustavy ozubených kol vzniká efektivní
            systém s&nbsp;výkonným hnacím motorem od&nbsp;vedení společnosti. Pokud bych měl ale vyzdvihnout pár věcí,
            tak mám největší radost z&nbsp;toho, že pracuji ve&nbsp;firmě, kde všichni táhnou za&nbsp;jeden provaz, máme
            rádi vyžití i&nbsp;mimo kancelář, ať už ve&nbsp;formě sportovních akcí nebo párty eventů, a&nbsp;co si
            budeme, když je přísun dobré kávy, pracuje se&nbsp;o&nbsp;něco lépe.
        </p>
    </>
);

const ContentEn: FC = () => (
    <>
        <h2 className="ui-typo-h5 mb-10">Who are you?</h2>
        <p className="mb-6">
            I&nbsp;graduated from a&nbsp;technical high school with a&nbsp;degree in mechanical engineering and then
            studied business management at university. I&apos;ve&nbsp;been playing hockey since I&nbsp;was 3 years old.
            At the end of my career, I&nbsp;wanted to stay in hockey and so I&nbsp;started my career as a&nbsp;hockey
            referee, which lasted 14 year and 7 of those years in the first league. All my time in hockey taught me
            mainly teamwork, which I&nbsp;need to be able to function well in a&nbsp;work team to feel comfortable and
            enjoy the work.
        </p>
        <p className="mb-6">
            I&nbsp;love spending time with my family and traveling, which is why my wife and I&nbsp;started
            a&nbsp;travel agency.
        </p>
        <p>Besides hockey, cycling and skiing, one of my hobbies is working at UX Fans.</p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What was before UX Fans?</h2>
        <p className="mb-6">
            My first work experience was during high school at my dad&apos;s family business. We were purchasing and
            selling decorative glassware. Tourists were the main buying force. With the coronavirus, sales dropped to
            almost nothing. That was the main reason I&nbsp;left.
        </p>
        <p className="mb-6">
            So I&nbsp;was looking for a&nbsp;job in a&nbsp;company that would not be affected by the coronavirus and
            I&nbsp;joined Cryrtur in Turnov as a&nbsp;product manager. After a&nbsp;few months I&nbsp;got the impression
            that a&nbsp;product manager is primarily a&nbsp;buffer between business and production. I&nbsp;also
            discovered that some colleagues were just &quot;doing their time&quot;. This didn&apos;t suit me, and so
            after about two or three months I&nbsp;started to learn programming in the evenings, with the prospect of
            a&nbsp;job opportunity that I&nbsp;would look forward to every morning and leave in the evening with
            a&nbsp;slight sadness in my heart that I&nbsp;wouldn&apos;t be back until the next day.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What brought you to UX Fans?</h2>
        <p className="mb-6">
            I&nbsp;knew I&nbsp;didn&apos;t want to go to another manufacturing company in a&nbsp;similar position.
            I&nbsp;sent out several CVs for IT positions, but no one came back with a&nbsp;concrete offer. It was only
            once, in between talking to Martin (CEO of UX Fans) that I&nbsp;mentioned that I&nbsp;had been programming
            for a&nbsp;while, enjoyed it and was looking for more or less any IT position where I&nbsp;could develop
            further.
        </p>
        <p className="mb-6">
            UX Fans had several projects going on at the time and needed a&nbsp;tester. After that, I&nbsp;had another
            meeting with Martin, where he introduced me in more detail the form of cooperation and the workload. The
            next day I&nbsp;took my resignation to the HR department in Turnov.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">What is your role in UX Fans?</h2>
        <p className="mb-6">
            I&nbsp;work as a&nbsp;software tester at UX Fans. In addition to testing newly developed functionality, my
            work includes a&nbsp;number of other activities that lead to successful releases and thus to satisfied
            customers. One of the main activities I&nbsp;am involved in that lead to successful software delivery and
            thus QA compliance is testing the software as a&nbsp;whole and its dependencies from a&nbsp;client, business
            or user perspective. In addition, I&nbsp;am also involved in writing test scenarios, acceptance criteria,
            automated end-to-end tests and visual regression tests, which are integral to proper QA.
        </p>
        <h2 className="ui-typo-h5 mb-10 mt-16">Do you enjoy being part of UX Fans?</h2>
        <p>
            Yeah, right :) I&nbsp;really enjoy watching UX Fans as a&nbsp;great working gear where a&nbsp;single cog
            would not perform any great glory, but wiring up the entire gear set creates an efficient system with
            a&nbsp;powerful drive from the company&apos;s management. But if I&nbsp;had to highlight a&nbsp;few things,
            I&nbsp;am most happy to work in a&nbsp;company where everyone pulls together, we enjoy activities outside
            the office whether in the form of sporting events or party events and what we will, when there is
            a&nbsp;supply of good coffee, work is a&nbsp;little better.
        </p>
    </>
);

export const PetrBosakStoryPage = memo(() => {
    const { t } = useTranslation();
    const locale = useLocale();

    const sidebar = (
        <Sidebar
            buttonUrl="https://www.linkedin.com/in/petr-bos%C3%A1k-3aa56b18a/"
            buttonText="LinkedIn"
            inCompanySince={t("story:petrBosak.inCompanySince")}
            position={t("story:petrBosak.position")}
            hashtags={BLOG_ARTICLES.find((a) => a.key === "petr-bosak")?.hashtags}
        />
    );

    return (
        <main>
            <BlogHeroSection title={t("story:petrBosak.title")} name="Petr Bosák">
                <StaticImage
                    src={petr}
                    alt=""
                    widths={[400, 400, 583, 448, 540, 583]}
                    width={583}
                    imgClassName="!w-full object-contain"
                />
            </BlogHeroSection>
            <MainSection className="mb-12 md:mb-20">
                <IntroSection sidebar={sidebar}>
                    <div className="ui-typo-body">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
                </IntroSection>
                <div className="mt-12 flex flex-col justify-between border-t pt-12 xl:hidden">{sidebar}</div>
            </MainSection>
        </main>
    );
});

PetrBosakStoryPage.displayName = "PetrBosakStoryPage";
